import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuditEntryDto, AuditQueryFilter } from '../dtos/audit-entry';
import { PaginatedResponse } from '../dtos/paginated';
import { Globals } from '../global/globals';

@Injectable({ providedIn: 'root' })
export class AuditTrailService {
  private baseUri: string;

  constructor(
    private http: HttpClient,
    private globals: Globals,
  ) {
    this.baseUri = this.globals.backendUri + '/projects';
  }

  getEntries(
    projectId: string,
    filter: AuditQueryFilter,
    page: number = 0,
    size: number = 50,
  ): Observable<PaginatedResponse<AuditEntryDto>> {
    let params = new HttpParams().set('page', page.toString()).set('size', size.toString());

    if (filter.actorId) params = params.set('actorId', filter.actorId);
    if (filter.action) params = params.set('action', filter.action);
    if (filter.stage) params = params.set('stage', filter.stage);
    if (filter.from) params = params.set('from', filter.from + 'T00:00:00Z');
    if (filter.to) params = params.set('to', filter.to + 'T23:59:59Z');
    if (filter.entityId) params = params.set('entityId', filter.entityId);

    return this.http.get<any>(`${this.baseUri}/${projectId}/audit-entries`, { params }).pipe(
      map((response) => ({
        items: (response.items || response.content || []).map(
          (item: any) =>
            new AuditEntryDto(
              item.id?.toString() ?? '',
              item.actorName ?? '',
              item.action ?? '',
              item.projectStage ?? '',
              item.description ?? '',
              item.payload ?? {},
              item.entityId ?? null,
              item.entityType ?? null,
              item.entityName ?? null,
              item.timestamp ?? '',
            ),
        ),
        totalItems: response.totalItems ?? response.totalElements ?? 0,
        totalPages: response.totalPages ?? 0,
        currentPage: response.currentPage ?? response.number ?? 0,
        pageSize: response.pageSize ?? response.size ?? 50,
      })),
    );
  }

  exportCsv(projectId: string, filter: AuditQueryFilter): Observable<Blob> {
    let params = new HttpParams();

    if (filter.actorId) params = params.set('actorId', filter.actorId);
    if (filter.action) params = params.set('action', filter.action);
    if (filter.stage) params = params.set('stage', filter.stage);
    if (filter.from) params = params.set('from', filter.from + 'T00:00:00Z');
    if (filter.to) params = params.set('to', filter.to + 'T23:59:59Z');
    if (filter.entityId) params = params.set('entityId', filter.entityId);

    return this.http.get(`${this.baseUri}/${projectId}/audit-entries/export-csv`, {
      params,
      responseType: 'blob',
    });
  }
}
